var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-block"},[_c('about-title',{attrs:{"title":_vm.t('mall_map')}}),_c('div',{staticStyle:{"height":"517px"},attrs:{"id":"pi-widget"}}),_c('mall-map-js')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }